import { getCookie } from "../utils/cookie";
import { getRequest, postRequest } from "../utils/fetch";
import { objectToQueryString } from "../utils/querystring";

export interface IAlternativeColor {
	readonly predefinedProductName: string;
	readonly color: string;
}

export interface IDesign {
	readonly packshotUrl: string;
	readonly defaultOptions: string;
}

interface IGetDesignRequest {
	productCode: string;
	designPredefinedProductName: string;
	pointOfSaleId: string;
	language: string;
	theme: string;
	mobile: boolean;
	alternativeIndex: boolean;
}

export function getDesign(productCode: string, designPredefinedProductName: string, theme: string): Promise<IDesign> {
	const request = {
		productCode,
		designPredefinedProductName,
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		theme: theme,
		mobile: false,
		alternativeIndex: getCookie("elastic") === "alternative",
	} as IGetDesignRequest;
	return postRequest<IGetDesignRequest, IDesign>("apicore/dspapi/getdesign", request, {
		headers: { "Content-type": "application/json; charset=utf-8" },
	}).then((res) => res as IDesign);
}
